export default {
  activeActivity: (state) => {
    return state.slide
  },
}
